export default "/assets/images/filter-mini.8dac1e3095e06c42.jpg";